module.exports = __webpack_public_path__ + "media/images/gc_select_device-b79e6ab2ccc1b7e6f628e1d03508ed59.png";